import DropdownTemplateView from '../../../../../DropdownTemplateView'
import ActionButton from './ActionButton'
import $ from 'jquery'

/**
 * @author makovchik.
 * @since 17.08.2018.
 */
export default class DropdownActionMenu extends DropdownTemplateView {
    constructor({
        actions = [],
    }) {
        super()

        this.params = {
            actions,
        }
    }

    templateHtml() {
        return "<div class='dropdownContainer addNewMenu'>" +
               "</div>"
    }

    afterRender() {
        this.params.actions.forEach((value) => {
            new ActionButton({
                title: value.title,
                extraClass: value.extraClass,
                actionClick: value.actionClick,
                hideMenu: this.hide.bind(this)
            }).init(this.$el)
        })
    }

    mouseDownTargetElement() {
        return $('body')
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/components/action/DropdownActionMenu.js